import React from "react";
import "./AboutUs.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const AboutUs = () => {
  return (
    <div>
      {/* <div class="preloader" id="preloader">
    <div class="preloader-inner">
        <div class="spinner">
            <div class="dot1"></div>
            <div class="dot2"></div>
        </div>
    </div>
</div> */}

      <div class="body-overlay" id="body-overlay"></div>
      <div class="search-popup" id="search-popup">
        <form
          action="http://zwin.io/html/riyaqas/index.html"
          class="search-form"
        >
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Search....." />
          </div>
          <button type="submit" class="submit-btn">
            <i class="fa fa-search"></i>
          </button>
        </form>
      </div>

      <Navbar />
      <div
        class="breadcrumb-area"
        style={{ backgroundImage: "url(assets/img/page-title-bg.png)" }}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb-inner">
                <h1 class="page-title">About</h1>
                <ul class="page-list">
                  <li>
                    <a href="index-2.html">Home</a>
                  </li>
                  <li>About</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="about-provide-area pd-top-120 bg-none">
        <div class="container">
          <div class="row">
            <div class="col-xl-7 col-lg-6">
              <div class="img-with-video">
                <div class="img-wrap">
                  <img src="assets/img/we-provide/1.png" alt="video" />
                  <div class="hover">
                    <a
                      href="https://www.youtube.com/watch?v=c7XEhXZ_rsk"
                      class="video-play-btn mfp-iframe"
                    >
                      <img src="assets/img/we-provide/3.svg" alt="video" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-5 col-lg-6 desktop-center-item">
              <div>
                <div class="section-title style-two">
                  <h2 class="title">
                    We is the <span>Riyaqas?</span>
                  </h2>
                  <p>
                    Riyaqas One of the best Software Development company.
                    Riyaqas is at the forefront as the most innovative web
                    development company. Our cost efficient and structured
                    teamwork justifies our position. Our clients count on our
                    offshore business solutions on a regular basis from concept.
                  </p>
                  <p>
                    Design to development, testing & implementation, our team is
                    here to support and guide you every step of the way. Riyaqas
                    One of the best Software Development company.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sbst-service-area pd-top-80">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-10">
              <div class="section-title text-center">
                <h2 class="title">
                  What We <span>Do?</span>
                </h2>
                <p>
                  Riyaqas One of the best Software Development company. Riyaqas
                  is at the forefront as the most innovative web development
                  company. Our cost efficient and structured teamwork justifies
                  our position.
                </p>
              </div>
            </div>
          </div>
          <div class="row custom-gutters-20 justify-content-center">
            <div class="col-lg-3 col-sm-6">
              <div class="single-service-2 text-center">
                <div class="thumb">
                  <img src="assets/img/startup/service/1.svg" alt="service" />
                </div>
                <h6>Consultation</h6>
                <p>
                  Riyaqas One of the best Software Development company.Riyaqas
                  is the forefront as the most innovative.
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="single-service-2 text-center">
                <div class="thumb">
                  <img src="assets/img/startup/service/2.svg" alt="service" />
                </div>
                <h6>Brand & Identity</h6>
                <p>
                  Riyaqas One of the best Software Development company.Riyaqas
                  is the forefront as the most innovative.
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="single-service-2 text-center">
                <div class="thumb">
                  <img src="assets/img/startup/service/3.svg" alt="service" />
                </div>
                <h6>Web Design</h6>
                <p>
                  Riyaqas One of the best Software Development company.Riyaqas
                  is the forefront as the most innovative.
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="single-service-2 text-center">
                <div class="thumb">
                  <img src="assets/img/startup/service/4.svg" alt="service" />
                </div>
                <h6>Apps Development</h6>
                <p>
                  Riyaqas One of the best Software Development company.Riyaqas
                  is the forefront as the most innovative.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="team-area-wrpper about-team-area-wrpper pd-top-112 mg-top-120">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-10">
              <div class="section-title text-center">
                <h2 class="title">
                  Riyaqas Creative <span>Team</span>
                </h2>
                <p>
                  Riyaqas One of the best Software Development company. Riyaqas
                  is at the forefront as the most innovative web development
                  company. Our cost efficient and structured teamwork.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="team-area text-center">
          <div class="container">
            <div class="row custom-gutters-20">
              <div class="col-lg-3 col-sm-6">
                <div class="single-team">
                  <div class="thumb">
                    <img src="assets/img/startup/team/1.jpg" alt="team" />
                  </div>
                  <h6>
                    <a href="#">Abedin Abed</a>
                  </h6>
                  <span>Creative Director</span>
                  <p>Riyaqas One of the best Software Development company.</p>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="single-team">
                  <div class="thumb">
                    <img src="assets/img/startup/team/2.jpg" alt="team" />
                  </div>
                  <h6>
                    <a href="#">Jabedin jabed</a>
                  </h6>
                  <span>Projector Manager</span>
                  <p>Riyaqas One of the best Software Development company.</p>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="single-team">
                  <div class="thumb">
                    <img src="assets/img/startup/team/5.png" alt="team" />
                  </div>
                  <h6>
                    <a href="#">Moin Khan</a>
                  </h6>
                  <span>Art Director</span>
                  <p>Riyaqas One of the best Software Development company.</p>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="single-team">
                  <div class="thumb">
                    <img src="assets/img/startup/team/3.jpg" alt="team" />
                  </div>
                  <h6>
                    <a href="#">Moin Khan</a>
                  </h6>
                  <span>Art Director</span>
                  <p>Riyaqas One of the best Software Development company.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="client-area pd-top-110">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-9">
              <div class="section-title style-two text-center">
                <h2 class="title">
                  What Our <span>Client Say?</span>
                </h2>
                <p>
                  Our support team will get assistance from AI-powered
                  suggestions, making it quicker than ever to handle support
                  requests. Our support team will get assistance from AI-powered
                  suggestions.
                </p>
              </div>
            </div>
          </div>
          <div class="client-slider">
            <div class="client-slider-item">
              <div class="media">
                <div class="media-left media-left-one">
                  <img src="assets/img/client/4.png" alt="client" />
                </div>
                <div class="media-body">
                  <h6>Madeniko Mojika</h6>
                  <p>Branding Idendity</p>
                </div>
              </div>
              <p class="client-content">
                Our support team will get assistance from AI-powered
                suggestions, making it quicker than ever to handle support
                requests.
              </p>
            </div>
            <div class="client-slider-item">
              <div class="media">
                <div class="media-left media-left-two">
                  <img src="assets/img/client/5.png" alt="client" />
                </div>
                <div class="media-body">
                  <h6>Madeniko Mojika</h6>
                  <p>Branding Idendity</p>
                </div>
              </div>
              <p class="client-content">
                Our support team will get assistance from AI-powered
                suggestions, making it quicker than ever to handle support
                requests.
              </p>
            </div>
            <div class="client-slider-item">
              <div class="media">
                <div class="media-left media-left-three">
                  <img src="assets/img/client/6.png" alt="client" />
                </div>
                <div class="media-body">
                  <h6>Madeniko Mojika</h6>
                  <p>Branding Idendity</p>
                </div>
              </div>
              <p class="client-content">
                Our support team will get assistance from AI-powered
                suggestions, making it quicker than ever to handle support
                requests.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <div class="back-to-top">
        <span class="back-top">
          <i class="fa fa-angle-up"></i>
        </span>
      </div>
    </div>
  );
};

export default AboutUs;
